import { triggerHostMessageOnCallSavedThirdParty } from '../triggerHostMessage/triggerHostMessageOnCallSavedThirdParty';
export default function handleOnCallSavedThirdParty(payload) {
  triggerHostMessageOnCallSavedThirdParty(payload);
}